import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

const baseStyles = ({ theme }) => css`
  padding: 0 1rem;

  @media (min-width: ${theme.media.tablet}) {
    padding: 0;
  }
`

const spacingStyles = ({ placement }) => {
  const margins = {
    top: css`
      margin-top: 16px;
    `,
    bottom: css`
      margin-bottom: 16px;
    `
  }

  return margins[placement]
}

const Spacing = styled('div')(baseStyles, spacingStyles)

Spacing.displayName = 'Spacing'

Spacing.propTypes = {
  placement: PropTypes.oneOf(['top', 'bottom'])
}

Spacing.defaultProps = {
  placement: 'bottom'
}

export default Spacing
